module.exports = __webpack_public_path__ + "img/487-979f91.png";